import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, mergeMap, map, exhaustMap, tap, finalize } from 'rxjs/operators';

import { of } from 'rxjs';
import {
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    addRecord,
    addRecordSuccess,
    addRecordFailure,
    updateRecord,
    updateRecordSuccess,
    updateRecordFailure,
    deleteRecord,
    deleteRecordSuccess,
    deleteRecordFailure,
    fetchSingleRecord,
    fetchSingleRecordSuccess,
    fetchSingleRecordFail
} from './communication-category.action';
import { AlertService } from 'src/app/core/services/alert.service';
import { CrudServerService } from 'src/app/core/services/crud-server.service';
import { RouterService } from 'src/app/core/services/router.service';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { CommunicationCategoryTableService } from './communication-category-table.service';
import { DatatableService } from 'src/app/core/services/datatable.service';
import { HelperService } from 'src/app/core/services/helper.service';

@Injectable()
export class CommunicationCategoryRecordEffects {

    fetchData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchRecords),
            exhaustMap(() => {
                const url = 'communication-category';
                return this.crudServerService.fetchTableData(url, this.moduleTableService).pipe(
                    map( (response) => {
                        const data = response.data;

                        this.moduleTableService.page = data.pagination.current_page;
                        this.moduleTableService.lastPage = data.pagination.last_page;
                        this.moduleTableService.pagination = this.tableService.getPaginationArray(data.pagination.current_page, data.pagination.last_page)
                        
                        this.alertService.triggerAlert(response.message, "success");
                        return fetchRecordsSuccess({listData: data.records, total: data.pagination.total});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => fetchRecordsFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    addData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(addRecord),
            exhaustMap((data: any) => {
                const url = 'communication-category';
                return this.crudServerService.addData(url, data.newData).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        this.routeService.triggerRoute(response, "/communication-category");
                        return addRecordSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => addRecordFailure({ error })) // Dispatch 
                        )
                    ),

                    finalize(() => {
                        this.helperService.formButtonDisabled = false;
                    })
                )
            })
        )
    );
    
    fetchSingle$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchSingleRecord),
            exhaustMap((data: any) => {
                const url = 'communication-category/'+data.id+"/edit";
                return this.crudServerService.fetchData(url).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        return fetchSingleRecordSuccess({singleData: response.data});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                                this.routeService.triggerRoute(null, "/communication-category");
                            }),
                            map(() => fetchSingleRecordFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    updateData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(updateRecord),
            exhaustMap((data:any) => {
                const url = 'communication-category-update/'+data.id;
                return this.crudServerService.updateDataPost(url, data.updatedData).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        this.routeService.triggerRoute(response, "/communication-category");
                        return updateRecordSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => updateRecordFailure({ error })) // Dispatch 
                        )
                    ),

                    finalize(() => {
                        this.helperService.formButtonDisabled = false;
                    })
                )
            })
        )
    );

    deleteData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(deleteRecord),
            exhaustMap((data: any) => {
                const url = 'communication-category/'+data.id;
                return this.crudServerService.deleteData(url).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        this.store.dispatch(fetchRecords());
                        this.routeService.triggerRoute(null, "/communication-category");
                        return deleteRecordSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => deleteRecordFailure({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    constructor(
        private actions$: Actions,
        private crudServerService: CrudServerService,
        private alertService: AlertService,
        private routeService: RouterService,
        private store: Store<RootReducerState>,
        private moduleTableService: CommunicationCategoryTableService,
        private tableService: DatatableService,
        public helperService: HelperService
    ) { }

}